export default __webpack_public_path__ + "static/media/1.27451768.jpg";